module.exports = __webpack_public_path__ + "img/exhibits - grayscale.094efd03.svg";